import { useContext } from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { getDisplayImageUrl } from '../../utils/imageUtils';

const MaintenancePage = () => {
  const { config } = useContext(ConfigContext);
  const brandName = config?.brand?.name || "L'ETÉ";
  const logo = config?.brand?.logo;
  const instagram = config?.socialLinks?.find(l => l.platform === 'instagram')?.url;
  const email = config?.socialLinks?.find(l => l.platform === 'email')?.url;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary, #faf9f7)',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '480px', width: '100%' }}>
        {/* Logo / Nombre */}
        {logo ? (
          <img
            src={getDisplayImageUrl(logo)}
            alt={brandName}
            style={{ height: '70px', objectFit: 'contain', marginBottom: '2.5rem' }}
          />
        ) : (
          <div style={{
            fontFamily: 'var(--font-heading, "Cormorant Garamond", serif)',
            fontSize: '2.2rem',
            fontWeight: 300,
            letterSpacing: '0.18em',
            color: 'var(--text-primary, #1a1a1a)',
            marginBottom: '2.5rem',
            textTransform: 'uppercase'
          }}>
            {brandName}
          </div>
        )}

        {/* Ícono */}
        <div style={{ marginBottom: '1.5rem' }}>
          <i className="fa-solid fa-wrench" style={{
            fontSize: '2rem',
            color: 'var(--text-muted, #999)'
          }}></i>
        </div>

        {/* Título */}
        <h1 style={{
          fontFamily: 'var(--font-heading, "Cormorant Garamond", serif)',
          fontSize: '1.8rem',
          fontWeight: 400,
          letterSpacing: '0.06em',
          color: 'var(--text-primary, #1a1a1a)',
          marginBottom: '1rem'
        }}>
          Estamos trabajando para vos
        </h1>

        {/* Subtítulo */}
        <p style={{
          fontFamily: 'var(--font-body, Inter, sans-serif)',
          fontSize: '1rem',
          color: 'var(--text-muted, #777)',
          fontWeight: 300,
          lineHeight: 1.7,
          marginBottom: '2.5rem'
        }}>
          Volvemos pronto con novedades.<br />
          Gracias por tu paciencia.
        </p>

        {/* Separador */}
        <div style={{
          width: '40px',
          height: '1px',
          background: 'var(--border-light, #e0d8d0)',
          margin: '0 auto 2rem'
        }} />

        {/* Links de contacto */}
        <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {instagram && (
            <a
              href={instagram}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontFamily: 'var(--font-body, Inter, sans-serif)',
                fontSize: '0.85rem',
                color: 'var(--text-muted, #777)',
                textDecoration: 'none',
                letterSpacing: '0.05em',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <i className="fa-brands fa-instagram"></i>
              Instagram
            </a>
          )}
          {email && (
            <a
              href={`mailto:${email}`}
              style={{
                fontFamily: 'var(--font-body, Inter, sans-serif)',
                fontSize: '0.85rem',
                color: 'var(--text-muted, #777)',
                textDecoration: 'none',
                letterSpacing: '0.05em',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <i className="fa-solid fa-envelope"></i>
              Contacto
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
